module.exports = "/lucky-balls/img/infobox/info_Box_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_009.png
// module id = 1074
// module chunks = 0